
import React, { Component } from 'react';
import { Route, Switch } from "react-router-dom";
import DepositDetails from './deposit-details';
import DepositsLists from './list-deposits';

export default class Deposits extends Component {


  render() {
    return (
      <div>

        <Switch>
          <Route exact path={`/payments/deposits`} component={DepositsLists} />
          <Route exact path={`/payments/deposits/:id`} component={DepositDetails} />
        </Switch>
      </div>
    )
  }
}